import React from "react";

import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";

// import { TextField } from "mui-rff";
// import { Form } from "react-final-form";
import { dataType } from "../GenericList/GenericList";
import moment from "moment";
import FdTextField from "../UIComponents/TextField/FdTextfield";
import FdTypography from "../UIComponents/Typography/FdTypography";
import { genericFieldsView as classes } from "./styles"
import { getFieldLabel } from "../../helpers/constants";

export type IProps = {
  item: any;
  csvType: dataType;
  csvMap: any;
};

const GenericFieldsView = ({ item, csvType, csvMap }: IProps) => {
  const getFieldValues = () => {
    return (Object.keys(item) as Array<keyof typeof item>)
      .filter((key) => item[key]?.length > 0)
      .map((key) => {
        return (
          <Box key={key.toString()}>
            <FdTextField
            // register={register}
              name={key.toString()}
              id={key.toString()}
              label={
                getFieldLabel(key.toString().charAt(0).toUpperCase() + key.toString().slice(1))
              }
              value={item[key]}
              disabled={true}
            />
          </Box>
        );
      });
  };

  const fieldValues = getFieldValues();
  return (
    <Box sx={classes.root}>
      {/* attendee info heading */}
      {csvType === dataType.ATTENDEES && (
        <Box sx={classes.infoTitle}>
          <Avatar sx={classes.avatar}>
            {item.imageUrl ? item.imageUrl : item.firstName[0]}
          </Avatar>
          <Box textAlign="left">
            <FdTypography
              label={`${item.firstName} ${item.lastName}`}
              variant="h2"
              component="h2"
              sx={{ marginBottom: "10px" }}
            />
            <FdTypography label={item.jobTitle} />
            <FdTypography label={item.company} />
          </Box>
        </Box>
      )}

      {/* session info heading */}
      {csvType === dataType.SESSIONS && (
        <Box sx={classes.infoTitle}>
          <Box textAlign="left">
            <FdTypography
              label={item.name}
              variant="h2"
              component="h2"
              style={{ marginBottom: "10px" }}
            />
            <FdTypography label={item.sessionLocation} />
            <FdTypography
              label={`${moment(item.start).format(
                "YYYY.MM.DD HH:mm"
              )} - ${" "} ${moment(item.end).format("YYYY.MM.DD HH:mm")}`}
            />
          </Box>
        </Box>
      )}
      <Box sx={classes.infoFields}>
        {/* <Form
          onSubmit={() => {}}
          initialValues={{}}
          render={({ handleSubmit, values }) => ( */}
            {/* <form onSubmit={handleSubmit} noValidate style={{ width: "100%" }}> */}
              {fieldValues}
            {/* </form> */}
          {/* )}
        /> */}
      </Box>
    </Box>
  );
};

export default GenericFieldsView;
